import React, { FC } from 'react';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import { Box, Typography, useTheme } from '@mui/material';
import ReviewWrapper from '../ReviewWrapper';
import ReviewHeader from '../ReviewHeader';
import ReviewContent from '../ReviewContent';
import ReviewFooter from '../ReviewFooter';
import { CommunityManagement } from '../../../shared/interfaces/ICommunityManagement';
import ReviewText from '../ReviewText';
import { Person } from '@mui/icons-material';

interface Props extends IReviewNewProps {}

const FewoReview: FC<Props> = ({
  communityManagement,
  commentingModule,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();

  const {
    username,
    rating,
    text,
    reviewTitle,
    companyComment,
    header,
    positiveFeedback,
    negativeFeedback,
    originalRating,
  } = reviewEntry.review;

  return (
    <ReviewWrapper
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={rating}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      {username && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <Person fontSize="small" />
          <Typography
            variant="body1"
            sx={{ ml: theme.spacing(1) }}
          >
            {username}
          </Typography>
        </Box>
      )}
      {reviewTitle && (
        <Typography
          variant="h6"
          sx={{ mt: theme.spacing(2) }}
        >
          {reviewTitle}
        </Typography>
      )}
      {header && (
        <Typography
          variant="h6"
          sx={{ mt: theme.spacing(2) }}
        >
          {header}
        </Typography>
      )}
      {positiveFeedback && (
        <Box>
          <Typography
            variant="h6"
            sx={{ mt: theme.spacing(2) }}
          >
            Positive Feedback
          </Typography>
          <Typography variant="body1">{positiveFeedback}</Typography>
        </Box>
      )}
      {negativeFeedback && (
        <Box>
          <Typography
            variant="h6"
            sx={{ mt: theme.spacing(2) }}
          >
            Negative Feedback
          </Typography>
          <Typography variant="body1">{negativeFeedback}</Typography>
        </Box>
      )}
      <ReviewText text={text} />
    </ReviewWrapper>
  );
};

export default FewoReview;
